/**
 * Shared result handling for the catchball command wrappers.
 *
 * The catchball RPCs refuse in two different ways: some RAISE (PostgREST error),
 * some RETURN `{ success: false, error: '…' }` with HTTP 200 — e.g.
 * catchball_create_revision_request's authority check (migration 713) and
 * catchball_deliver_involvement (718). A wrapper that only checks `error`
 * reports the second kind as a success. Every wrapper goes through here so a
 * refusal is always thrown, carrying the server's own text.
 */
export function unwrapRpcResult<T>(
  data: unknown,
  error: { message: string } | null | undefined,
  fallback: string,
): T {
  if (error) {
    throw new Error(error.message || fallback);
  }
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const envelope = data as { success?: unknown; error?: unknown };
    if (envelope.success === false) {
      throw new Error(
        typeof envelope.error === 'string' && envelope.error.trim() !== ''
          ? envelope.error
          : fallback,
      );
    }
  }
  return data as T;
}
